/*Sidebar*/

import i_vias from './../UI/icons/Sidebar/Vias2.svg'
import i_vias2 from './../UI/icons/Sidebar/Vias.svg'
import i_beneficios from './../UI/icons/Sidebar/Puntos-interes2.svg'
import i_beneficios2 from './../UI/icons/Sidebar/Puntos-interes.svg'
import i_amenidades from './../UI/icons/Sidebar/Amenidades.svg'
import i_amenidades2 from './../UI/icons/Sidebar/Amenidades2.svg'
import i_etapas from './../UI/icons/Sidebar/Proyecto2.svg'
import i_etapas2 from './../UI/icons/Sidebar/Proyecto.svg'

import i_renders from './../UI/icons/Galerias/renders.svg'
import i_recor from './../UI/icons/Galerias/360.svg'
import i_back from './../UI/icons/back-btn.svg'

/*Amenities*/

import i_gym from './../UI/icons/Amenities/Gym.svg'
import i_gym2 from './../UI/icons/Amenities/Gym_orange.svg'
import i_Club from './../UI/icons/Amenities/SalonSocial_orange.svg'
import i_Club2 from './../UI/icons/Amenities/SalonSocial.svg'
import i_Lago from './../UI/icons/Amenities/Lago_orange.svg'
import i_Lago2 from './../UI/icons/Amenities/Lago.svg'
import i_SalónComunal from './../UI/icons/Amenities/Salon Social_orange.svg'
import i_SalónComunal2 from './../UI/icons/Amenities/Salon Social.svg'
import i_quintoPiso2 from './../UI/icons/Amenities/Lobby.svg'
import i_quintoPiso from './../UI/icons/Amenities/Lobby_orange.svg'



/*POIS*/
import i_salud from './../UI/icons/POI/Salud.svg'
import i_comercio from './../UI/icons/POI/Comercio.svg'
import i_otros from './../UI/icons/POI/Otros.svg'
import i_colegios from './../UI/icons/POI/Educacion.svg'
import i_parques from './../UI/icons/POI/Parques.svg'
import i_proyectos from './../UI/icons/POI/ProyectosVecinos.svg'
import i_proyectos2 from './../UI/icons/POI/ProyectosVecinos_White.svg'
import i_salud2 from './../UI/icons/POI/Salud2.svg'
import i_comercio2 from './../UI/icons/POI/Comercio2.svg'
import i_otros2 from './../UI/icons/POI/Otros2.svg'
import i_colegios2 from './../UI/icons/POI/Educacion2.svg'
import i_parques2 from './../UI/icons/POI/Parques2.svg'

export default {
    /*Sidebar*/
    'vias': i_vias,
    'vias2': i_vias2,
    'beneficios': i_beneficios,
    'beneficios2': i_beneficios2,
    'amenidades': i_amenidades,
    'amenidades2': i_amenidades2,
    'etapas': i_etapas,
    'etapas2': i_etapas2,
    'renders': i_renders,
    'recorridos': i_recor,
    'back': i_back,

    /*Amenidades*/
     'Gimnasio Exterior': i_gym,
     'Gimnasio Exterior2': i_gym2,
     'Gimnasio Interior2': i_gym2,
     'Gimnasio Interior': i_gym,
     'Salón Comunal2': i_SalónComunal,
     'Salón Comunal': i_SalónComunal2,
     'Portería2': i_quintoPiso,
     'Portería': i_quintoPiso2,
     'Lago2': i_Lago,
     'Lago': i_Lago2,
     'Club House2': i_Club,
     'Club House': i_Club2,


    /**/
    "Salud": i_salud,
    "Salud2": i_salud2,
    "Comercio": i_comercio,
    "Comercio2": i_comercio2,
    "Otros": i_otros,
    "Otros2": i_otros2,
    "Educación": i_colegios,
    "Educación2": i_colegios2,
    "Parques": i_parques,
    "Parques2": i_parques2,
    "Proyectos Cercanos2": i_proyectos,
    "Proyectos Cercanos": i_proyectos2
}

